<template>
  <div class="listmain ">
    <h1 class="firTitle">Android硬件SDK集成</h1>

    <h3 class="sedTitle">1.SDK概要</h3>
    <p>猎户星空语音SDK主要以语音交互的方式为主提供猎户云OS的相关Skill为主。运行在android平台上，以aar的方式进行集成。</p>

    <h3 class="sedTitle">2.SDK结构图</h3>
    <img src="../../../static/images/sdk1.png" alt="img">

    <h3 class="sedTitle">3.SDK接入指南</h3>
    <p>A.猎户客户端SDK : orion-sdk-release.aar 复制到集成项目中的libs文件夹下
    </p>
    <p>B.在项目的build.gradle中dependencies中加入如下配置：
    </p>
    <highlight-code lang="javascript">
                                dependencies {
                compile 'com.android.support:support-annotations:24.2.0'
                compile 'com.google.code.gson:gson:2.7'
                compile 'com.squareup.retrofit2:retrofit:2.0.2'
                compile 'com.squareup.retrofit2:converter-gson:2.0.2'
                compile 'com.squareup.okhttp3:okhttp:3.2.0'
              }

    </highlight-code>
    <p>C.想使用相关的语音OS技能，需要在对应的manifest.xml中添加如下认证信息：
    </p>
    <highlight-code lang="javascript">
            &lt;!-- TODO: 根据对应的产品来进行替换 默认小雅 --&gt;
            &lt;!-- 猎户语音认证信息 --&gt;
            &lt;meta-data
            android:name="orion_ovs_client_id"
            android:value="orion.ovs.client.1506671192754" /&gt;
           &lt;meta-data
            android:name="orion_ovs_secret"
            android:value="00BCE7B0476EC85DE72E4F129DBF9E63" /&gt;
            &lt;!-- 猎户用户中心认证信息 --&gt;
           &lt;meta-data
            android:name="orion_user_center_client_id"
            android:value="orion.ucenter.ee779207ebb816bc" /&gt;
            &lt;meta-data
            android:name="orion_user_center_secret"
            android:value="421814004b0643968f1ff3a7e2b7aa86" /&gt;
            &lt;!-- 对应远场语音解码器 不需要修改--&gt;
            &lt;meta-data
            android:name="orion_asr_pid"
            android:value="61" /&gt;

     </highlight-code>

    <p>D.初始化SDK
    </p>
    <highlight-code lang="javascript">
             //初始化SDK
              KratosSDK.getInstance().init(this);
              //设置音频资源获取回调接口
              KratosSDK.getInstance().setResourceFetcher(new SoundResourceFetcherImpl());
              //设置灯效事件监听回调接口
              KratosSDK.getInstance().setLightListener(new LightEffectsListenerImpl());
              //设置蓝牙相关操作实现接口
              KratosSDK.getInstance().setBluetoothOperator(new BluetoothOperatorImpl());
              //设置关机相关操作实现接口
              KratosSDK.getInstance().setPowerListener(new PowerOffListenerImpl());
              //设置是否接管唤醒的实现接口
              KratosSDK.getInstance().setSessionListener(new IWakeupResultHandleListenerImpl());
              //设置是否接管指令的实现接口
              KratosSDK.getInstance().setCommandEventListener(new CommandEventImpl());

    </highlight-code>
    <p>E.猎户语音SDK的语音识别认证是基于PackageName会对内部license_resource做校验，开发者需要申请对应的license_resource。 相关细节参考SDK API文档以及对应的SDK Demo.
    </p>

    <h3 class="sedTitle">4.百度和虾米音乐部分的接入方式</h3>
    <p>
      接入SDK的音箱方，如小雅音箱，需要使用虾米和百度的第三方资源，需按如下步骤配置：
    </p>
    <h3 class="thirdTitle">一. 虾米资源：</h3>
    <p>
      a) 导入库文件
    </p>
    <p>
      (1) 将 libencryptor.so 放在项目对应的 libs/armeabi 目录下。
    </p>
    <p>
      (2) 将 xiami-music-sdk-2.2.1.jar 拷贝到工程的 libs 目录下。
    </p>
    <p>
      b) 在build.gradle 文件中配置
    </p>
    <highlight-code lang="javascript">
          dependencies {
                     compile files('libs/xiami-music-sdk-2.2.1.jar')
              }

    </highlight-code>
     <p>
        c) 添加权限
    </p>
    <highlight-code lang="javascript">
        &lt;!-- 获取当前wifi状态 --&gt;
        &lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;
        &lt;uses-permission android:name="android.permission.INTERNET" /&gt;
        &lt;!-- 读取网络信息状态 --&gt;
        &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;
        &lt;!-- 允许程序改变网络连接状态 --&gt;
        &lt;uses-permission android:name="android.permission.CHANGE_NETWORK_STATE" /&gt;
        &lt;!-- 读取手机信息权限 --&gt;
       &lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;

    </highlight-code>
      <p>
      d) 配置AndroidManifest 
    </p>
    <highlight-code lang="javascript">
      &lt;meta-data
       android:name="orion_enable_xiami"
       android:value="1" /&gt;


    </highlight-code>
    <h3 class="thirdTitle">二. 百度资源：</h3>
    <p>a) 导入库文件</p>
    <p>  (1) 将 baidu-musicsdk-3.2.5.aar 拷贝到工程的 libs 目录下。</p>
    <p>b) 在build.gradle 文件中配置</p>
    <highlight-code lang="javascript">
           dependencies {
               compile(name: 'baidu-musicsdk-3.2.5', ext: 'aar')
         }

    </highlight-code>
     <p>c) 配置AndroidManifest </p>
    <highlight-code lang="javascript">
      &lt;meta-data
         android:name="orion_enable_baidu"
         android:value="1" /&gt;

    </highlight-code>

     <h3 class="sedTitle">SDK的FAQ</h3>

     <p>1.能否提供像Demo APK（orion-sdk-demo-debug-1113.apk） 的source code作为开发的参考</p>
     <p>答: Demo的Source code可以提供，SDK会以库的方式集成到整个Demo中，方便接入方参考，但是SDK库的相关功能代码，目前猎户并没有开源的计划。</p>
      <p>2.集成SDK都需要什么？</p>
      <p>答: 只需要将SDK的对应库(android平台上的一个aar),集成到要接入的apk工程中即可。</p>
      <p>3.提供license_resource的相关资料（类似API Key）</p>
      <p>答: 使用猎户云SDK需要以下权限：
        <br>a)猎户语音认证:包含client_id和secret 由接入方申请，和对应接口人联系 由猎户提供开通。
        <br>b)猎户用户中心认证：包含client_id和secret 由接入方申请，和对应接口人联系 由猎户提供开通。
        <br>c)ASR使用认证： 由接入方申请:并提供正式的包名(package name)
        <br>由猎户提供: 对应的license文件和开通ASR的pid
        <br>相关信息需要集成到接入方工程中，以android平台为例如下图
        <br>在要集成的接入方APP总的AndroidManifest.xml中进行如下配置

      </p>
      <highlight-code lang="javascript">
          &lt;!-- TODO: 根据对应的产品来进行替换 默认小雅-北京 --&gt;
          &lt;!-- 猎户语音认证信息 --&gt;
          &lt;meta-data
          android:name="orion_ovs_client_id"
          android:value="orion.ovs.client.1506671192754" /&gt;
          &lt;meta-data
          android:name="orion_ovs_secret"
          android:value="00BCE7B0476EC85DE72E4F129DBF9E63" /&gt;
          &lt;!-- 猎户用户中心认证信息 --&gt;
          &lt;meta-data
          android:name="orion_user_center_client_id"
          android:value="orion.ucenter.ee779207ebb816bc" /&gt;
          &lt;meta-data
          android:name="orion_user_center_secret"
          android:value="421814004b0643968f1ff3a7e2b7aa86" /&gt;
          &lt;!-- 对应解码器 --&gt;
          &lt;meta-data
          android:name="orion_asr_pid"
          android:value="7011" /&gt;

          &lt;!-- TODO: 根据对应的产品来进行替换 台湾对应的配置 --&gt;
          &lt;meta-data
          android:name="orion_ovs_client_id"
          android:value="orion.ovs.client.1512644432726" /&gt;
          &lt;meta-data
          android:name="orion_ovs_secret"
          android:value="6BD70DA66FEC2ECE6D416F6162E2D1A5" /&gt;
          &lt;!-- 猎户用户中心认证信息 --&gt;
          &lt;meta-data
          android:name="orion_user_center_client_id"
          android:value="orion.ovs.client.1512644432726" /&gt;
          &lt;meta-data
          android:name="orion_user_center_secret"
          android:value="6BD70DA66FEC2ECE6D416F6162E2D1A5" /&gt;

      </highlight-code>

      <p>4.如何切换到Free talk mode</p>
     <p>答: 1)不需要唤醒的直接query，只在特定的场景下会触发（如播放音乐的过程中，前60S可以直接说一些指令而无需唤醒(这些指令如，下一首，换一首，暂停等)），目前这部分功能只针对特定的领域(domain)开发，不支持自定义。
       <br>
       2)多伦会话支持，也是在特定的场景下触发(可以通过后台针对特殊场景来配置)
       <br>如用户说“我想设置一个闹钟”
       <br>对话(音箱)回复“要设置什么时间的闹钟呢？”
       <br>用户可以说“明天早上8点的闹钟”
       <br>对话回复“好的已经为您设置好XXX的闹钟”
     </p>
      <p>5.如何触发Skill&相对应的API，例如：要触发閙钟/提醒这个skill，本地端和云端要呼叫那些API。</p>
     <p>答: Skill的功能都是基于语音交互的方式，是通过用户的query经过NLP的解析后，落到一个特定的领域中(domain)，直接触发了这个技能。如例子中的场景：用户通过query和音箱交互，说“给我定个明天8点的闹钟”，这句话在后台如果经过解析domain落到了“提醒/闹钟”的领域中，会自动触发这个skill,如果设置成功，会返回一段TTS来提示用户，如“已经为您设置好明天8点的闹钟”等等。
       <br>
      另外，如果有一些本地特殊的表现，可以通过后台经过语义理解返回的特殊数据格式，来做自己本地的特有表现。
     </p>
      <p>6.有无方法可以上传自订的QA</p>
     <p>答: 这部分可以理解成为，自定义skill的相关词典内容，这里目前需要和猎户的NLP对应的同学，针对特定的业务需求场景来特殊定义。
     </p>
      <p>7.QA所接收到的Answer如果有含YouTube连结，有无方法播放</p>
     <p>答: SDK中包含了对应用于播放的播放器组件部分，如果通过Query点中了音乐领域，返回的对应音乐的url，只要当前网络部分是通常的，没有限制的，就可以通过该url来获取音乐部分的数据，进行播放。
     </p>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/ASDK.vue